import { PostalAddress } from 'src/types/types'

export enum UserType {
  Sender = 'sender',
  Receiver = 'receiver',
}

export interface UserAddress {
  postalAddress: PostalAddress
  streetAddress: string
}

export interface CartState {
  isCartDrawerOpen: boolean
  userType: UserType
  cartDetails: CartDetails
}

export interface CartDetails extends CartBillingInfo {
  [UserType.Sender]?: UserAddress
  [UserType.Receiver]: UserAddress
}

export interface CartAdressInfo {
  postalCode: string
  streetAddress: string
  city: string
}

export interface BillingShippingAddress {
  address_1: string
  address_2: string
  city: string
  company: string
  country: string
  email: string
  first_name: string
  last_name: string
  phone: string
  postcode: string
  state: string
}

export interface CartBillingInfo {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  additionalInfo: string
  collectionDate: string
  billing_address?: BillingShippingAddress
  shipping_address?: BillingShippingAddress
}
